// extracted by mini-css-extract-plugin
module.exports = {"section-header":"SectionHeader_section-header__U1Wfu","section-header__title":"SectionHeader_section-header__title__rG7zD"};